import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConstantConfig } from '../config/constant.config';
import { MsgConstantConfig } from '../config/message.constant.config';
import { PathConfig } from '../config/path.config';
import { AuthService } from './auth-service';
import { BroadcastService } from './broadcaster.service';
import { ClientDetailService } from './client-detail-service';
import { LocalStorageService } from './local-storage.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private http: HttpClient, private router: Router, private clientDetailService: ClientDetailService, private msgService: MessageService, private localStorageService: LocalStorageService, private auth: AuthService,
    private titleService: Title,
       private broadCastService: BroadcastService,) {
  }

  init(): Promise<boolean> {
    return new Promise((resolve, reject) => {

      const windowURL = window.location.pathname.split("/");
      const clientId = (windowURL.length > 1) ? windowURL[1] : '';
      const token = this.localStorageService.get(clientId + "_"  + ConstantConfig.AUTH_TOKEN);
      const url =  token && token!='idle' ? `${PathConfig.LS_CLIENTS_DETAIL}/${clientId}`: `${PathConfig.CLIENT_DATA}?slug=${clientId}`;
      if (!clientId) {
        resolve(false);
        window.location.href = environment.LOGIN_URL;
      }
      this.http.get(url).subscribe((response:any) => {
        if(url?.includes('client_data')){
          if(response?.logo_light){
            response['logo_light_temp_url'] = response?.logo_light;
          }
          if(response?.logo_dark){
            response['logo_dark_temp_url'] = response?.logo_dark;
          }
        }
        this.clientDetailService.setClientInfo(response);
        sessionStorage.setItem(ConstantConfig.CLIENT_SLUG, clientId);
        this.titleService.setTitle(this.clientDetailService.TITLE);
        const favicon = environment.IMG_URL + this.clientDetailService.FAVICON;
        (document as any).querySelector("link[rel*='icon']").href = favicon;
        resolve(true);
      }, (err) => {
        resolve(false);
        const status = err?.status ?? '';
        //this work in local not in deployed version dev/QA for service down>incorrect slug>error page show
        // if (status === 503) {
        //   const currentClientSlug = window.location.pathname.split("/")[1];
        //   const token = this.localStorageService.get(currentClientSlug + "_" + ConstantConfig.AUTH_TOKEN)
        //   !token && this.router.navigate(['/error-404'], { queryParams: { fp: 'F' }, replaceUrl: true });
        // }
        switch (status) {
          case 400:
            // this.msgService.showError(err?.error?.message || 'Service Unavailable');
            // this.router.navigate(['/error-404'], { queryParams: { fp: 'F' }, replaceUrl: true });
            if (err?.error?.maintenance_mode == "ON") {
              setTimeout(() => {
                this.broadCastService.broadcast(MsgConstantConfig.MAINTENANCE);
              }, 1000);
              if (err?.error?.message) {
                err.error.message = '';
              }
            }
            break;
          case 404:
            this.router.navigate(['/error-404'], { queryParams: { fp:'F'}, replaceUrl: true });
            this.msgService.showError(err?.error?.message || 'Service Unavailable');
            break;
          case 403:
            this.router.navigate(['/error-403'], { queryParams: { fp: 'F' } });
            break;
          case 503:
          case 0:
            setTimeout(()=>{
              this.broadCastService.broadcast(MsgConstantConfig.SERVICE_UNAVAILABLE);
            });
            break;
          default:
            // this.router.navigate(['/error-404'], { queryParams: { fp: 'F' } });
            this.msgService.showError(err?.error?.message || 'Service Unavailable');
            break;
        }

      })
    });
  }
}